import dateTime from 'system/libs/dateTime';

define((require, exports, module) => {
    'use strict';

    /**
     * @constructor
     * @param {Error} stack – ошибка для быстрой навигации по коду.
     * @param {string} source – источник проблемы: backend, web-backend, web-client.
     */
    function UploadReason(stack, source) {
        if (!(this instanceof UploadReason)) {
            throw new TypeError(UploadReason.ERROR_WRONG_INSTANCE);
        }

        if (this.constructor === UploadReason) {
            throw new TypeError(UploadReason.ERROR_ABSTRACT_CLASS);
        }

        if (!(stack instanceof Error)) {
            throw new TypeError(UploadReason.ERROR_NO_STACK);
        }

        if (
            source !== UploadReason.SOURCE_BACKEND &&
            source !== UploadReason.SOURCE_WEB_BACKEND &&
            source !== UploadReason.SOURCE_WEB_CLIENT
        ) {
            throw new TypeError(UploadReason.ERROR_WRONG_SOURCE);
        }

        this.timeStamp = Date.now();
        this.stack = stack;
        this.source = source;
        this.radarName = this.radarName.replace('{SOURCE}', source);
    }

    Object.assign(UploadReason, {
        ERROR_WRONG_INSTANCE:
            'UploadReason called on non-instance of UploadReason',
        ERROR_ABSTRACT_CLASS: 'UploadReason is abstract class',
        ERROR_NO_STACK: 'UploadReason requires stack',
        ERROR_WRONG_SOURCE: 'wrong UploadReason source',

        SOURCE_BACKEND: 'backend',
        SOURCE_WEB_BACKEND: 'web-backend',
        SOURCE_WEB_CLIENT: 'web-client',
    });

    UploadReason.prototype = {
        constructor: UploadReason,

        /**
         * @type {string}
         */
        className: 'UploadReason',

        /**
         * @type {string}
         */
        radarName: 'reason_{SOURCE}_abstract',

        /**
         * @type {string}
         */
        message: 'Не загружено.',

        /**
         * Источник ошибки: backend, web-backend, web-client.
         * @type {string}
         */
        source: 'abstract',

        /**
         * @type {number}
         */
        timeStamp: -1,

        /**
         * Возможность повторить попытку.
         * @type {boolean}
         */
        isRetryable: false,

        /**
         * Ошибка для быстрой навигации по коду.
         * @type {Error}
         */
        stack: null,

        /**
         * uploadDescriptor.id
         * @type {string}
         */
        id: '',

        /**
         * @type {string}
         */
        timePattern: 'hh:ss:mm.SSS(z)',

        /**
         * @type {string}
         */
        toStringPattern: '{MESSAGE}',

        toString() {
            let result = this.toStringPattern;

            result = result.replace('{MESSAGE}', this.message);

            return result;
        },

        /**
         * @type {string}
         */
        toLogStringPattern: '[{TIME}] {ID} {SOURCE} {CLASS_NAME}',

        toLogString() {
            const time = dateTime.format(this.timeStamp, this.timePattern);
            let result = this.toLogStringPattern;

            result = result.replace('{TIME}', time);
            result = result.replace('{ID}', this.id);
            result = result.replace('{SOURCE}', this.source);
            result = result.replace('{CLASS_NAME}', this.className);

            return result;
        },

        /**
         * @returns {Object}
         */
        getDetails() {
            // TODO: add feature param: log stack to kaktam
            return {
                id: this.id,
                source: this.source,
                type: this.className,
                timeStamp: this.timeStamp,
            };
        },
    };

    module.exports = UploadReason;
});
